import { Box } from '@mui/material';

import type { WallBoard, WallCard } from '@walls/store';
import { CardBody } from './CardBody';
import { CardFrame } from './CardFrame';
import { CardOwnerLabel } from './CardOwnerLabel';
import { useCardPermissions } from './hooks/useCardPermissions';
import { useParticipantName } from './hooks/useParticipantName';
import { getCardFrameDimensions } from './utils/cardGeometry';

interface TriangleCardProps {
  board: WallBoard;
  card: WallCard;
  isClusterChild?: boolean;
  measureDependencies?: unknown[];
}

export function TriangleCard({
  board,
  card,
  isClusterChild = false,
  measureDependencies = [],
}: TriangleCardProps) {
  const dimensions = getCardFrameDimensions(card);
  const permissions = useCardPermissions(board, card);
  const participantName = useParticipantName(card.ownerId);
  const ownerName = permissions.showOwnerName ? participantName : '';

  return (
    <CardFrame
      board={board}
      card={card}
      isClusterChild={isClusterChild}
      measureDependencies={measureDependencies}
      sx={{
        boxShadow: 'none',
        filter: card.isLocked ? 'none' : 'drop-shadow(0 1px 0 rgba(0, 0, 0, 0.2))',
        height: dimensions.height,
        minHeight: 100,
        minWidth: 100,
        width: dimensions.width,
      }}
    >
      <Box
        sx={{
          borderBottom: `${dimensions.height}px solid ${card.color || '#ffff99'}`,
          borderLeft: `${dimensions.width / 2}px solid transparent`,
          borderRight: `${dimensions.width / 2}px solid transparent`,
          height: 0,
          position: 'absolute',
          width: 0,
        }}
      />
      <Box sx={{ display: 'flex', height: '100%', position: 'relative', width: '100%' }}>
        <CardBody board={board} card={card} centered triangle />
      </Box>
      <CardOwnerLabel ownerName={ownerName} placement="below" />
    </CardFrame>
  );
}
